module.exports = __webpack_public_path__ + "static/media/68ed9628.jpg";